export default function ImageCredit({ image, testid }) {
  if (!image?.credit) return null;
  return (
    <>
      {" "}
      <a
        href={image.creditUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className="normal-case text-bronze underline-offset-4 transition-colors hover:underline"
      >
        {image.credit}
      </a>
    </>
  );
}
